import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/gmsyzs.jpg'
import _imports_1 from '../../assets/img/adhl.jpg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-e2b8a1b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-UVA" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title f-size-24 f-col-white08" }, "无人机巡河")
], -1))
const _hoisted_5 = { class: "list" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "无人机巡河列表", -1))
const _hoisted_7 = { class: "info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "航飞基本信息", -1))
const _hoisted_9 = { class: "content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "飞行时间：", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "飞行里程：", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "任务描述：", -1))
const _hoisted_13 = { class: "content" }
const _hoisted_14 = {
  key: 0,
  class: "video-box"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "航飞视频", -1))
const _hoisted_16 = { class: "video" }
const _hoisted_17 = { class: "map-box" }
const _hoisted_18 = { class: "tabs" }
const _hoisted_19 = { class: "content" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"legend\" data-v-e2b8a1b4><h6 data-v-e2b8a1b4>氨氮含量</h6><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅰ,Ⅱ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅲ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅳ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅴ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>劣Ⅴ类</span></p></div>", 1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"legend\" data-v-e2b8a1b4><h6 data-v-e2b8a1b4>总磷含量</h6><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅰ,Ⅱ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅲ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅳ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅴ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>劣Ⅴ类</span></p></div>", 1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  id: "gpfy-ad-ljx",
  ref: "gpfyADljx"
}
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"legend\" data-v-e2b8a1b4><h6 data-v-e2b8a1b4>氨氮含量</h6><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅰ,Ⅱ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅲ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅳ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅴ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>劣Ⅴ类</span></p></div>", 1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  id: "gpfy-zl-ljx",
  ref: "gpfyZLljx"
}
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"legend\" data-v-e2b8a1b4><h6 data-v-e2b8a1b4>总磷含量</h6><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅰ,Ⅱ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅲ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅳ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅴ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>劣Ⅴ类</span></p></div>", 1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  id: "gpfy-gmsj-ljx",
  ref: "gpfyGMSJljx"
}
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"legend\" data-v-e2b8a1b4><h6 data-v-e2b8a1b4>高锰酸钾含量</h6><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅰ,Ⅱ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅲ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅳ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>Ⅴ类</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>劣Ⅴ类</span></p></div>", 1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  id: "gpfy-hcst-ljx",
  ref: "gpfyHCSTljx"
}
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"legend\" data-v-e2b8a1b4><h6 data-v-e2b8a1b4>黑臭水体含量</h6><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>正常水体</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>轻度黑臭</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>中度黑臭</span></p><p data-v-e2b8a1b4><span class=\"color\" style=\"background:#f22d2d;\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>重度黑臭</span></p></div>", 1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  id: "gpfy-sh-ljx",
  ref: "gpfySHljx"
}
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"legend\" data-v-e2b8a1b4><h6 data-v-e2b8a1b4>水华</h6><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>无水华</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>无明显水华</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>轻度水华</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>中度水华</span></p><p data-v-e2b8a1b4><span class=\"color\" data-v-e2b8a1b4></span><span data-v-e2b8a1b4>重度水华</span></p></div>", 1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wxdz" }, null, -1))
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]

import { nextTick, markRaw, onMounted, onBeforeUnmount } from 'vue'
import { ref } from 'vue'
import Bus from '@/config/Bus'
import { THREE } from 'threebox-plugin'
import { MapService } from '@/utils/mapServices2'
import Video from 'video.js'
import { Api, LyQuery } from '@/api/publicApi'
import { useMainStore } from '@/store/main'
import pinia from '@/store/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogUVA',
  props: {
  data: Object,
},
  setup(__props) {

const api = new Api()
const mainStore = useMainStore(pinia)
const mapService2 = new MapService()
const mapServiceAD = new MapService()
const mapServiceZL = new MapService()
const mapServiceADljx = new MapService()
const mapServiceZLljx = new MapService()
const mapServiceHCSTljx = new MapService()
const mapServiceSHljx = new MapService()
const mapServiceGMSJljx = new MapService()
const props = __props

const defaultExpandedKeys = ref<string[]>([])
const gpfyAD = ref()
const gpfyZL = ref()
const warning = ref(false)
const playState = ref(false)
const mapState = ref(false)
const tabKey = ref('航飞轨迹')
const timer = ref()
const changTimeInt = ref()
const listData = ref([
  {
    label: '九龙河',
    children: [
      {
        label: '飞行视频1',
      },
    ],
  },
])
const details = ref({})
const pointsV3 = ref([])
const video = ref()
let player: {
  on: (arg0: string, arg1: () => void) => void
  play: () => void
  ready: (arg0: () => void) => void
  currentTime: (arg0: number) => void
}

const getWrjFlightDetailByIdUsingGET = () => {
  api.screen.getWrjFlightDetailByIdUsingGet({ id: props.data.id }).then((res) => {
    if (res.code === 200) {
      details.value = res.data || {}
      listData.value = [
        {
          label: res.data?.ly || '',
          children: [],
        },
      ]
      setTimeout(() => {
        initMap()
        getVideo()
      }, 1000)
    }
  })
}
const initMap = () => {
  mapService2.initMap(
    {
      container: 'hfgj',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/ht新河长大屏-详情.json',
      center: [105.86517773950351, 29.297694887532586],
      zoom: 15,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapService2.map.once('styledata', () => {
    mapState.value = true
    mapService2.flyTo({
      center: [parseFloat(details.value.startJd), parseFloat(details.value.startWd)],
    })
    mapService2.addPointLayer(
      'UAVPoint',
      [parseFloat(details.value.startJd), parseFloat(details.value.startWd)],
      '',
      'UAV.png',
      0.9,
      'center'
    )
    // getPoint()
    flightTrajectory()
  })
}

const getVideo = () => {
  if (details.value.videoUrl) {
    const option = {
      muted: false,
      // controls: true,
      loop: false,
      autoplay: false,
      sources: [
        {
          type: 'video/mp4',
          src: details.value.videoUrl, // url地址
          // src: 'https://xcx.ljh.cqhtwl.com.cn/files/wrj-fly/dji_export_164932067523%E5%BE%B7%E8%83%9C%E6%A1%A5%E5%88%B0%E7%9F%AE%E5%A2%A9%E6%A1%A5.mp4', // url地址
        },
      ],
      notSupportedMessage: '此视频暂无法播放，请稍后再试',
      // poster:,
      // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
    }
    // 初始化的时候标签默认都是显示的
    player = Video(video.value, option, () => {
      // this.play();
      player.on('error', () => {
        player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
        console.log('视频加载错误')
        let time = 0
        changTimeInt.value = setInterval(() => {
          changTime(time)
          time++
          if (time > 600) {
            time = 0
          }
        }, 100)
      })
      player.on('pause', () => {
        playState.value = false
        clearInterval(timer.value)
      })
      player.on('timeupdate', changTime)
    })
    playState.value = true
    flightTrajectory()
    player.play().then(() => {
      player.on('play', () => {
        playState.value = true
      })
      playState.value = true
      flightTrajectory()
    })
  } else {
    playState.value = true
    flightTrajectory()
    let time = 0
    changTimeInt.value = setInterval(() => {
      changTime(time)
      time++
      if (time > 600) {
        time = 0
      }
    }, 100)
  }
}

// 渲染轨迹
const flightTrajectory = () => {
  if (playState.value && mapState.value) {
    let duration = player ? player.duration() : 600
    duration ? '' : (duration = 600)
    /* eslint-disable */
    // const trajectory = [
    //   [105.86517773950351, 29.297694887532586],
    //   [105.89617773950351, 29.297694887532586],
    //   [105.89617773950351, 29.250694887532586],
    // ];
    const trajectory = JSON.parse(details.value.flightpath)
    const myArray = []
    for (let i = 0; i < trajectory.length; i += 1) {
      myArray.push(new THREE.Vector3(trajectory[i][0], trajectory[i][1], 0))
    }
    const curve = new THREE.CatmullRomCurve3(myArray)
    pointsV3.value = curve.getPoints(duration * 20)
    const newLine = []
    for (let i = 0; i < pointsV3.value.length; i += 1) {
      newLine.push([pointsV3.value[i].x, pointsV3.value[i].y])
    }
    mapService2.drawTrajectory('trajectory', newLine, '', 6, 'UAVPoint')
    // const line = turf.lineString(trajectory);
    // const chunk = turf.lineChunk(line, 0.01, { units: 'miles' });
    // const sample = turf.sample(chunk, 5);
    // console.log(chunk);
    // console.log(sample);
    // const sample = turf.sample(
    //   {
    //     type: 'FeatureCollection',
    //     features: [
    //       {
    //         type: 'Feature',
    //         geometry: {
    //           type: 'LineString',
    //           coordinates: trajectory,
    //         },
    //       },
    //     ],
    //   },
    //   5,
    // );
    // let i = 0;
    // this.timer = setInterval(() => {
    //   const data = {
    //     type: 'FeatureCollection',
    //     features: [
    //       {
    //         type: 'Feature',
    //         geometry: {
    //           type: 'Point',
    //           coordinates: [this.pointsV3[i].x, this.pointsV3[i].y],
    //         },
    //       },
    //     ],
    //   };
    //   mapService2.map.getSource('UAVPoint').setData(data);
    //   if (i < this.pointsV3.length - 1) {
    //     i += 1;
    //     // console.log(i);
    //   } else {
    //     i = 0;
    //     console.log(this.timer);
    //     clearInterval(this.timer);
    //   }
    // }, 10);
  }
}

function changTime(_time: number) {
  let index: number
  if (typeof _time == 'number') {
    index = parseInt(_time * 20, 10)
  } else {
    index = parseInt(player.currentTime() * 20, 10)
  }
  if (timer.value) {
    clearInterval(timer.value)
  }
  if (playState.value) {
    timer.value = setInterval(() => {
      const data = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [pointsV3.value[index].x, pointsV3.value[index].y],
            },
          },
        ],
      }
      index += 1
      mapService2.map.getSource('UAVPoint').setData(data)
    }, 50)
  } else {
    const data = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [pointsV3.value[index].x, pointsV3.value[index].y],
          },
        },
      ],
    }
    index += 1
    mapService2.map.getSource('UAVPoint').setData(data)
  }
}

//光谱反演
const initMapGPFW = () => {
  let legendAD = gpfyAD.value.getElementsByClassName('legend')[0]
  let legendZL = gpfyZL.value.getElementsByClassName('legend')[0]
  gpfyAD.value.innerHTML = ''
  gpfyZL.value.innerHTML = ''
  gpfyAD.value.appendChild(legendAD)
  gpfyZL.value.appendChild(legendZL)
  mapServiceAD.initMap(
    {
      container: 'gpfy-ad',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06252, 29.40677],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceAD.map.once('styledata', () => {
    mapServiceAD.showLayer('szfy-ad')
  })
  mapServiceZL.initMap(
    {
      container: 'gpfy-zl',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06252, 29.40677],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceZL.map.once('styledata', () => {
    mapServiceZL.showLayer('szfy-zl')
  })

  mapServiceZLljx.initMap(
    {
      container: 'gpfy-zl-ljx',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06452, 29.39377],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceZLljx.map.once('styledata', () => {
    mapServiceZLljx.showLayer('ljx_zl总磷')
  })
  mapServiceADljx.initMap(
    {
      container: 'gpfy-ad-ljx',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06452, 29.39377],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceADljx.map.once('styledata', () => {
    mapServiceADljx.showLayer('ljx_ad氨氮')
  })
  mapServiceHCSTljx.initMap(
    {
      container: 'gpfy-hcst-ljx',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06452, 29.39377],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceHCSTljx.map.once('styledata', () => {
    mapServiceHCSTljx.showLayer('ljx_boi黑臭水体')
  })
  mapServiceSHljx.initMap(
    {
      container: 'gpfy-sh-ljx',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06452, 29.39377],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceSHljx.map.once('styledata', () => {
    mapServiceSHljx.showLayer('ljx_rvi水华')
  })
  mapServiceGMSJljx.initMap(
    {
      container: 'gpfy-gmsj-ljx',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06452, 29.39377],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceGMSJljx.map.once('styledata', () => {
    mapServiceGMSJljx.showLayer('ljx_gmsj高锰酸钾')
  })
}

const nodeProps = ({ option }: { option: any }) => {
  return {
    onClick(n: { path: { className: string }[] }) {
      if (option.children) {
        if (n.path[0].className !== 'n-checkbox-box__border') {
          if (defaultExpandedKeys.value.indexOf(option.label) == -1) {
            defaultExpandedKeys.value.push(option.label)
          } else {
            defaultExpandedKeys.value.splice(defaultExpandedKeys.value.indexOf(option.label), 1)
          }
        }
      }
    },
  }
}

const getPoint = () => {
  const params: LyQuery = {
    ly: '永川全区域',
  }
  api.screen.getGyqyPointUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '工业企业')
    }
  })
  api.screen.getGyyqPointUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '工业园区')
    }
  })
  api.screen.wsclcStatisticsClickPointUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '污水处理厂')
    }
  })
  api.screen.getNmscListUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '农贸市场')
    }
  })
  api.screen.getCyqyListUsingPost().then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '餐饮企业')
    }
  })
  api.screen.getXqyzListUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '畜牧养殖', '畜禽养殖场')
    }
  })
  api.screen.getScyzListUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '水产养殖', '水产养殖场')
    }
  })
  api.screen.getBasicClickPointListUsingPost({ ...params, no: 8000 }).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '沿河排口')
    }
  })
}

const showLayer = (data: string | any[] | undefined, type: string, icon: string | undefined) => {
  let pointList = []
  for (let i = 0; i < data.length; i++) {
    switch (data[i].category) {
      case '雨水排口':
        icon = '雨水排口'
        break
      case '污水排口':
        icon = '污水排口'
        break
      case '雨污混排':
        icon = '雨污排口'
      default:
    }
    let properties = { ...data[i], modalType: type, icon: icon ? `${icon}.png` : `${type}.png` }
    if (properties.psName) {
      properties.name = properties.psName
    }
    if (properties.mc) {
      properties.name = properties.mc
    }
    if (properties.qymc) {
      properties.name = properties.qymc
    }
    pointList.push({
      coordinates: [
        data[i].jd
          ? parseFloat(data[i].jd)
          : data[i].lon
            ? parseFloat(data[i].lon)
            : parseFloat(data[i].Longitude),
        data[i].wd
          ? parseFloat(data[i].wd)
          : data[i].lat
            ? parseFloat(data[i].lat)
            : parseFloat(data[i].Latitude),
      ],
      properties: properties,
    })
  }
  mapServiceAD.addPointsLayer(type, pointList, '', 0.8, 'bottom', true)
  mapServiceZL.addPointsLayer(type, pointList, '', 0.8, 'bottom', true)
}

onMounted(() => {
  initMapGPFW()
  getWrjFlightDetailByIdUsingGET()
})

onBeforeUnmount(() => {
  if (timer.value) {
    clearInterval(timer.value)
  }
  if (changTimeInt.value) {
    clearInterval(changTimeInt.value)
  }
  mapService2.map.remove()
  mapServiceAD.map.remove()
  mapServiceZL.map.remove()
  mapServiceADljx.map.remove()
  mapServiceZLljx.map.remove()
  mapServiceHCSTljx.map.remove()
  mapServiceSHljx.map.remove()
  mapServiceGMSJljx.map.remove()
  player.off('timeupdate', changTime)
})

return (_ctx: any,_cache: any) => {
  const _component_n_tree = _resolveComponent("n-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_n_tree, {
            ref: "layers-manage-tree",
            "block-line": "",
            cascade: "",
            checkable: "",
            data: listData.value,
            "key-field": "label",
            "default-checked-keys": _ctx.defaultCheckedKeys,
            "default-expanded-keys": defaultExpandedKeys.value,
            "node-props": nodeProps,
            "check-strategy": "child",
            selectable: "",
            "onUpdate:checkedKeys": _ctx.handleCheckedKeysChange
          }, null, 8, ["data", "default-checked-keys", "default-expanded-keys", "onUpdate:checkedKeys"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("p", null, _toDisplayString(details.value.createTime), 1),
            _hoisted_11,
            _createElementVNode("p", null, _toDisplayString(details.value.distance) + "km", 1),
            _hoisted_12,
            _createElementVNode("p", null, _toDisplayString(details.value.description), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (details.value.videoUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("video", {
                  ref_key: "video",
                  ref: video,
                  controls: "",
                  class: "video video-js vjs-default-skin vjs-big-play-centered"
                }, null, 512)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane", tabKey.value == '航飞轨迹' ? 'active' : '']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (tabKey.value = '航飞轨迹'))
            }, " 航飞轨迹 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane", tabKey.value == '光谱反演' ? 'active' : '']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (tabKey.value = '光谱反演'))
            }, " 光谱反演 ", 2),
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(["tab-pane", tabKey.value == '卫星对照' ? 'active' : '']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (tabKey.value = '卫星对照'))
            }, " 卫星对照 ", 2), [
              [_vShow, warning.value]
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_19, [
            (details.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  id: "hfgj",
                  class: "hfgj",
                  style: _normalizeStyle(details.value.id == 3 ? 'width: 150rem' : 'width: 60rem')
                }, null, 4))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["gpfy", tabKey.value == '光谱反演' ? 'active' : '']),
              style: _normalizeStyle(details.value.id == 3 ? 'width: 150rem' : '')
            }, [
              _hoisted_20,
              _withDirectives(_createElementVNode("div", null, _hoisted_23, 512), [
                [_vShow, details.value.id == 4]
              ]),
              _withDirectives(_createElementVNode("div", {
                id: "gpfy-ad",
                ref_key: "gpfyAD",
                ref: gpfyAD
              }, _hoisted_25, 512), [
                [_vShow, details.value.id == 2]
              ]),
              _withDirectives(_createElementVNode("div", {
                id: "gpfy-zl",
                ref_key: "gpfyZL",
                ref: gpfyZL
              }, _hoisted_27, 512), [
                [_vShow, details.value.id == 2]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_28, _hoisted_30, 512), [
                [_vShow, details.value.id == 3]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_31, _hoisted_33, 512), [
                [_vShow, details.value.id == 3]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_34, _hoisted_36, 512), [
                [_vShow, details.value.id == 3]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_37, _hoisted_39, 512), [
                [_vShow, details.value.id == 3]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_40, _hoisted_42, 512), [
                [_vShow, details.value.id == 3]
              ])
            ], 6),
            _withDirectives(_createElementVNode("div", null, _hoisted_45, 512), [
              [_vShow, tabKey.value == '卫星对照']
            ])
          ], 512), [
            [_vShow, details.value]
          ])
        ])
      ])
    ])
  ]))
}
}

})